import React from "react";

function Title({ title }) {
  return (
    <h3 className="font-square text-5xl sm:text-7xl font-bold pb-3">{title}</h3>
  );
}

export default Title;
